import type { FunctionComponent } from "react";
import { useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";

import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import homeLatestContentItemContentFragmentNode from "scmp-app/queries/__generated__/homeLatestContentItemContent.graphql";
import type { homeLatestContentItemContent$key } from "scmp-app/queries/__generated__/homeLatestContentItemContent.graphql";

import { Item, MetaWrapper } from "./styles";

type Props = {
  edition: string;
  reference: homeLatestContentItemContent$key;
};

export const ItemTrendingNavBarLatestSwiper: FunctionComponent<Props> = ({
  edition,
  reference,
}) => {
  const content = useFragment<homeLatestContentItemContent$key>(
    homeLatestContentItemContentFragmentNode,
    reference,
  );
  const providers = useContentItemProviders(content);

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: `oneline_menu_trending_${edition}`,
        pgtype: "homepage",
      }}
    >
      <Item as={content.urlAlias} pathname={content.urlAlias}>
        <MetaWrapper>
          {providers.publishedDate({ displayMode: "timeAgo" })}
          {providers.liveTag({ variant: "transparent" })}
        </MetaWrapper>
        {providers.headline({ hideTag: true, hideTooltip: true, preferSocialHeadline: true })}
      </Item>
    </BaseLinkContextProvider>
  );
};

ItemTrendingNavBarLatestSwiper.displayName = "ItemTrendingNavBarLatestSwiper";
